<template>
  <app-filter
    :title="$t('Customer Filter')"
    :filters="filterConfig"
    :filter-submitting="filterSubmitting"
    @filter="handleFilter"
  >
    <div slot="extra-actions">
      <b-button
        id="create-new-btn"
        variant="primary"
        class="create-new-btn"
        @click="createCustomer"
      >
        <feather-icon icon="PlusIcon" size="15" />
        {{ $t('Create Customer') }}
      </b-button>
    </div>
  </app-filter>
</template>

<script>
import AppFilter from '@/components/AppFilter/AppFilter.vue';
import { BButton } from 'bootstrap-vue';
import useService from '@/auth/service/useService';

export default {
  name: 'CustomerFilter',
  components: { AppFilter, BButton },

  props: {
    filterSubmitting: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      filterConfig: [
        {
          id: 'name',
          label: 'Customer Name',
          type: 'text',
          placeholder: 'Customer Name'
        },
        {
          id: 'status',
          label: this.$t('Usage Status'),
          type: 'select',
          options: [],
          placeholder: this.$t('Usage Status')
        },
        {
          id: 'approvalStatus',
          label: this.$t('Account Approval'),
          type: 'select',
          options: [
            { label: this.$t('Rejected'), value: 0 },
            { label: this.$t('Approved'), value: 1 },
            { label: this.$t('Pending'), value: 2 },
            { label: this.$t('In Review'), value: 3 }
          ],
          placeholder: this.$t('Account Approval')
        }
      ]
    };
  },
  async created() {
    try {
      const response = await useService.getCustomerStatusTypes();
      const items = Array.isArray(response?.data) ? response.data : [];
      const normalized = this.normalizeStatusOptions(items);
      this.setStatusFilterOptions(normalized);
      this.$emit('status-options-loaded', this.toTextValue(normalized));
    } catch (e) {
      this.setStatusFilterOptions([]);
    }
  },

  methods: {
    normalizeStatusOptions(items) {
      return (items || []).map(item => ({
        label:
          item && (item.info || item.label || item.text)
            ? String(item.info || item.label || item.text).replace(/^__/, '')
            : '',
        value: item?.value
      }));
    },
    toTextValue(options) {
      return (options || []).map(o => ({ text: o.label, value: o.value }));
    },
    getStatusFilterRef() {
      return this.filterConfig.find(f => f.id === 'status');
    },
    setStatusFilterOptions(options) {
      const statusFilter = this.getStatusFilterRef();
      if (statusFilter) {
        statusFilter.options = options || [];
      }
    },
    handleFilter(filters) {
      this.$emit('filter', filters);
    },

    createCustomer() {
      this.$router.push('/customers/create');
    }
  }
};
</script>
